<template>
  <v-container fluid fill-height>
    <v-toolbar color="green darken-1" dark app fixed flat>
      <v-toolbar-title style="width: 300px;" class="ml-5 pl-3">
          <a :href="`${webUrl}`" target="_blank">
        <img src="@/assets/logo.png" style="width: 150px; height: 70px;" alt>
          </a>
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <div class="text-xs-center">
        <v-menu offset-y>
          <template v-slot:activator="{ on }">
          </template>
          <v-list>
           
          </v-list>
        </v-menu>
      </div>
    </v-toolbar>
    <v-layout wrap style="margin-top: 150px">
        <v-flex xs12>
            <center><span style="color: green; font-size: 16px">Phone Number successfully updated.  </span> <a :href="`${host}/#/login/vip_sonko/normal`" target="_blank">Login Now</a> </center>
        </v-flex>
    </v-layout>
    <!-- app snackbar -->
    <app-snackbar ref="snackbar"></app-snackbar>
    <!-- end -->

  </v-container>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "packagesList",
  computed: {
    ...mapGetters(["user"]),
    ...mapGetters(["host"]),
    ...mapGetters(["webUrl"])
  },
  data() {
    return {
      radios: null,
      radioGroup: null,
      packages: [],
      items: [
        { text: "Log Out", actionType: "logout" }
      ]
    };
  },
  methods: {
    menuAction(data) {
      if (data == "logout") {
        const accountType = this.user.accountType;
        this.$store.commit("removeUser");
        localStorage.removeItem("token");
        this.$router.push(`/login/${accountType}/normal`);
      } else if (data == "account") {
        this.$router.push("/vip_sonko/profile");
      }
    },
    showMessage() {
      this.$refs.snackbar.show("Please select a plan and pay to complete your profile , if you have paid contact our customer service for help.", "red");
    }
  },
  created() {
    this.$store.dispatch("get", "/packages/vip").then(res => {
      this.packages = res.packages;
    });
  }
};
</script>

<style scoped>
.options {
  border-bottom: 1px solid #eeeeee;
}

ul li {
  list-style: none;
}

.v-input--radio-group .v-input__slot {
  margin-bottom: 4px;
}
</style>



